import React from 'react';
import axios from 'axios';
import classNames from 'classnames';
import {I18n} from 'react-i18nify';
// import {store} from '../../index';
import Config from '../config';
import _ from 'lodash';
import jwtDecode from "jwt-decode";

export function classNamesPrefixed(classes, prefix = true) {
    const prefixedClasses = {};

    _.each(classes, (trueOrFalse, className) => {
        if (prefix) {
            prefixedClasses[Config.prefix + className] = trueOrFalse;
        } else {
            prefixedClasses[className] = trueOrFalse;
        }
    });

    return classNames(prefixedClasses);
}

export function filterPages(data, search, contentDefinitionKey) {
    const result = [];

    for (let element of data) {
        let match = true;
        let hidden = false;

        if (search && search !== null && contentDefinitionKey && contentDefinitionKey !== null) {
            let searchMatch = _.includes(element.title.toLowerCase(), search.toLowerCase());
            let filterMatch = element.contentDefinitionKey === contentDefinitionKey;

            match = searchMatch === true && filterMatch === true;
        } else {
            if (search && search !== null) {
                match = _.includes(element.title.toLowerCase(), search.toLowerCase());
            }

            if (contentDefinitionKey && contentDefinitionKey !== null) {
                match = element.contentDefinitionKey === contentDefinitionKey;
            }
        }

        if (match === false && element.children.length === 0) {
            hidden = true;
        }

        if (match === false && hidden === false) {
            const children = filterPages(element.children, search, contentDefinitionKey);

            if (children.length === 0) {
                hidden = true;
            }
        }

        if (hidden === false) {
            const item = {
                ...element,
                children: []
            };

            if (element.children.length > 0) {
                item.children = filterPages(element.children, search, contentDefinitionKey);

                if (item.children.length > 0) {
                    item.expanded = true;
                }
            }

            result.push(item);
        }
    }

    return result
}

export function GenerateRecursiveChildsWithParams(data, parentWorkspaceId, onClick, selected, search = false, blockType, level = 1) {
    const results = [];

    data.forEach((item) => {
        let itemSelected = false;
        let disabled = false;
        let hidden = false;
        let match = false;

        if (_.isArray(selected)) {
            itemSelected = _.find(selected, {contentId: item.id});
        } else {
            itemSelected = selected === item.id;
        }

        if (search) {
            match = _.includes(item.title.toLowerCase(), search.toLowerCase());

            if (match) {
                disabled = false;
            } else {
                disabled = true;
            }
        }

        if (search) {
            if (disabled) {
                if (item.children.length === 0) {
                    hidden = true;
                }
            }
        }

        results.push(
            <li key={item.id}>
                <div onClick={(e) => {
                    e.preventDefault();

                    onClick(parentWorkspaceId, item.id, item.title);
                }}
                     className={classNamesPrefixed({
                         'item': true,
                         'match': match,
                         'selected': itemSelected,
                         'disabled': disabled,
                         'hidden': hidden,
                         ['level-' + level]: true
                     })}
                >
                    {item.title} ({item.contentDefinitionKey})
                </div>
                <ul>
                    {GenerateRecursiveChildsWithParams(item.children, parentWorkspaceId, onClick, selected, search, blockType, level + 1)}
                </ul>
            </li>
        );
    });

    return results;
}

export function GetFlatArrayFromRecursive(data, level = 1, results = []) {
    data.forEach((content) => {
        results.push(content);

        if (content.children && content.children.length > 0) {
            GetFlatArrayFromRecursive(content.children, level + 1, results);
        }
    });

    return results;
}

export function GetArrayFromRecursive(data, level = 1, results = []) {
    let prefix = '';

    for (let i = 0; i < level; i++) {
        prefix += '-';
    }

    data.forEach((content) => {
        results.push({
            id: content.id,
            title: prefix + ' ' + content.title,
            definition: content.contentDefinitionKey,
        });

        if (content.children && content.children.length > 0) {
            GetArrayFromRecursive(content.children, level + 1, results);
        }
    });

    return results;
}

export async function GenerateRelatedContents(values) {
    const data = {};

    if (values) {
        if (values.AreaBlocks) {
            await Promise.all(values.AreaBlocks.map(async (id) => {
                const response = await axios.get(Config.api.endpoint + 'api/content/' + id + '/' + values.languageId,Config.getApiConfig());

                if (response.data) {
                    data[id] = response.data;
                }
            }));
        }

        if (values.TableBlock) {
            await Promise.all([values.TableBlock].map(async (id) => {
                const response = await axios.get(Config.api.endpoint + 'api/content/' + id + '/' + values.languageId,Config.getApiConfig());

                if (response.data) {
                    data[id] = response.data;
                }
            }));
        }

        if (values.LevelDescBlock) {
            await Promise.all([values.LevelDescBlock].map(async (id) => {
                const response = await axios.get(Config.api.endpoint + 'api/content/' + id + '/' + values.languageId,Config.getApiConfig());

                if (response.data) {
                    data[id] = response.data;
                }
            }));
        }

        if (values.BlockArea) {
            await Promise.all(values.BlockArea.map(async (id) => {
                const response = await axios.get(Config.api.endpoint + 'api/content/' + id + '/' + values.languageId,Config.getApiConfig());

                if (response.data) {
                    data[id] = response.data;
                }
            }));
        }

        if (values.SliderBlockArea) {
            await Promise.all(values.SliderBlockArea.map(async (id) => {
                const response = await axios.get(Config.api.endpoint + 'api/content/' + id + '/' + values.languageId,Config.getApiConfig());

                if (response.data) {
                    data[id] = response.data;
                }
            }));
        }

        if (values.MyBlock) {
            await Promise.all([values.MyBlock].map(async (id) => {
                const response = await axios.get(Config.api.endpoint + 'api/content/' + id + '/' + values.languageId,Config.getApiConfig());

                if (response.data) {
                    data[id] = response.data;
                }
            }));
        }

        if (values.SomeBlocks) {
            await Promise.all(values.SomeBlocks.map(async (id) => {
                const response = await axios.get(Config.api.endpoint + 'api/content/' + id + '/' + values.languageId,Config.getApiConfig());

                if (response.data) {
                    data[id] = response.data;
                }
            }));
        }

        if (values.IconBlocks) {
            await Promise.all(values.IconBlocks.map(async (id) => {
                const response = await axios.get(Config.api.endpoint + 'api/content/' + id + '/' + values.languageId,Config.getApiConfig());

                if (response.data) {
                    data[id] = response.data;
                }
            }));
        }

        if (values.TextBlocks) {
            await Promise.all(values.TextBlocks.map(async (id) => {
                const response = await axios.get(Config.api.endpoint + 'api/content/' + id + '/' + values.languageId,Config.getApiConfig());

                if (response.data) {
                    data[id] = response.data;
                }
            }));
        }
    }

    return data;
}

export function ProcessRelatedContents(fields, results = []) {
    if (fields) {
        _.each(fields, (field) => {
            results[field.id] = ProcessContentFields(field.contentFields);

            if (field.contentDefinitionKey) {
                results[field.id].contentDefinitionKey = field.contentDefinitionKey;
                results[field.id].contentVisibilityTypeId = field.contentVisibilityId;
                results[field.id].allowedDivisions = field.allowedDivisions;
            }

            if (field.relatedContents && field.relatedContents.length) {
                ProcessRelatedContents(field.relatedContents, results);
            }
        });
    }

    return results;
}

export function ProcessContentFields(fields) {
    const values = {};

    if (fields) {
        fields.forEach((field) => {
            try {
                values[field.fieldDefinitionKey] = JSON.parse(field.data);
            } catch (e) {
                values[field.fieldDefinitionKey] = field.data;
            }
        });
    }

    return values;
}

export function ProcessContentStatusFields(fields) {
    const values = {};

    if (fields) {
        fields.forEach((field) => {
            values[field.fieldDefinitionKey] = field.enabled;
        });
    }

    return values;
}

export function ProcessGlobalFields(relatedContents, results = []) {
    if (relatedContents) {
        _.each(relatedContents, (relatedContent) => {
            if (relatedContent.globalFieldData && relatedContent.globalFieldData.length > 0) {
                _.each(relatedContent.globalFieldData, globalFieldData => {
                    results[globalFieldData.key] = [];

                    try {
                        results[globalFieldData.key]['data'] = JSON.parse(globalFieldData.data);
                    } catch (e) {
                        results[globalFieldData.key]['data'] = globalFieldData.data;
                    }

                    if (globalFieldData.relatedContents) {
                        results[globalFieldData.key]['related'] = ProcessRelatedContents(globalFieldData.relatedContents);
                    } else {
                        results[globalFieldData.key]['related'] = [];
                    }
                });
            }
        });
    }

    return results;
}

export function ProcessContentValuesCreate(values, fieldDefinitions) {
    if (values) {
        const data = {};

        data.contentFields = [];

        if (fieldDefinitions) {
            fieldDefinitions.forEach((field) => {
                if (values[field.key]) {
                    if (typeof values[field.key] !== 'string') {
                        data.contentFields.push({
                            'fieldDefinitionKey': field.key,
                            'data': JSON.stringify(values[field.key])
                        });
                    } else {
                        data.contentFields.push({
                            'fieldDefinitionKey': field.key,
                            'data': values[field.key]
                        });
                    }
                }
            });
        }

        return data;
    } else {
        return [];
    }
}

export function ProcessContentValuesEdit(values, fieldDefinitions) {
    const fields = [];

    if (fieldDefinitions) {
        fieldDefinitions.forEach((field) => {
            if (values[field.key]) {
                if (typeof values[field.key] !== 'string') {
                    fields.push({
                        'fieldDefinitionKey': field.key,
                        'data': JSON.stringify(values[field.key])
                    });
                } else {
                    fields.push({
                        'fieldDefinitionKey': field.key,
                        'data': values[field.key]
                    });
                }
            }
        });
    }

    return fields;
}

export function GetContentTitle(values) {
    if (values && values.contentFields) {
        const field = _.find(values.contentFields, {fieldDefinitionKey: 'Title'});

        if (field) {
            return field.data;
        }
    }
}

export function GetContentType(values, type) {
    if (type === 'page' && values.contentDefinitionKey) {
        return I18n.t('content.' + values.contentDefinitionKey);
    }

    if (type === 'block' && values.contentDefinitionKey) {
        return I18n.t('block.' + values.contentDefinitionKey);
    }

    return '';
}

export function GetContent(values) {
    let content = [];

    if (values && values.contentFields) {
        _.each(values.contentFields, (contentField, index) => {
            if (contentField.fieldDefinitionKey !== 'Title') {
                content.push(<div key={index} dangerouslySetInnerHTML={{__html: contentField.data}}/>)
            }
        });
    }

    return content;
}

export function isActiveMenu(currentPath, path, startsWith = false, pageTitle) {
    let isActive = false;

    if (startsWith) {
        isActive = currentPath.startsWith(startsWith);
    } else {
        isActive = currentPath === path;
    }

    if (isActive){
        if (pageTitle && pageTitle!==document.title){
            document.title = pageTitle;
        }
    }
    return isActive;
}

export function fixUrl(url) {
    return url;
}


export function mediaPreviewUrl(imageObject) {
    return Config.api.getCdnEndPoint() + "api/media/" + imageObject.ref + "/preview";
}

export function mediaUrl(imageObject) {
    return Config.api.getCdnEndPoint() + "api/media/" + imageObject.ref + "/file";
}

export function mediaDownloadUrl(imageObject) {
    return Config.api.getCdnEndPoint() + "api/media/" + imageObject.ref + "/file?download=1";
}

export function normalizeItems(items, parentId = null) {
    const result = [];

    for (let element of items) {
        const item = {
            id: element.id,
            parentId: parentId,
            title: element.title,
            children: []
        };

        if (element.children && element.children.length > 0) {
            item.children = normalizeItems(element.children, element.id)
        }

        result.push(item)
    }

    return result
}

export function findItem(items, id) {
    let result = null;

    for (let element of items) {
        if (element.id === id) {
            result = {
                id: element.id,
                parentId: element.parentId,
                title: element.title
            };

            break
        }

        if (element.children.length > 0) {
            result = findItem(element.children, id);

            if (result) {
                break;
            }
        }
    }

    return result
}

export function createActiveMenuArray(items, itemId, result = []) {
    const item = findItem(items, itemId);

    if (item) {
        result.push(item.id);

        if (item.parentId) {
            createActiveMenuArray(items, item.parentId, result)
        }
    }
    return result
}


export function getPageUrl(id){
    if (Config.frontURL){
        return Config.frontURL + '#/page/' + id;
    }
    return '#/page/' + id;
}


export function isLogged(){
    return Config.getToken() ? true : false;
}

export function isAdmin(){

    let token = Config.getToken();
    if (token){
        let decodedToken = jwtDecode(token);
        if (decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]==="Admin"){
            return true;
        }
    }
    return false;
}

export function makeid() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}


export function getRoleIdFromRoleName(roleName){

    let roleId = 0;
    switch (roleName) {

        case "LineManager":
            roleId = 2;
            break;

        case "Admin":
            roleId = 3;
            break;

        case "Employee":
            roleId = 1;
            break;

        default:
            roleId = 0;
            break;
    }

    return roleId;
}

export function getRequest(url,actionPrefix){
    return (dispatch) => {
        dispatch({
            type: actionPrefix+'_LOADING'
        });
        return axios.get(url, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: actionPrefix+'_SUCCESS',
                    payload: response.data
                });
            } else {
                dispatch({
                    type: actionPrefix+'_FAILURE',
                    payload: null
                });
            }
        }).catch(error => {
            dispatch({
                type: actionPrefix+'_FAILURE',
                payload: error
            });
        });
    }
}
export function firstWordStrong(text){
    if (text){
        let words = text.toString().split(" ");
        if (words.length>0){
            let firstWord = words.shift();
            return {strong:firstWord,regular:words.join(" ")};
        } else {
            return {strong:text,regular:""};
        }
    }
    return {strong:"",regular:""};
}

export function getLinkObj(itemData){

    let link = null;
    let linkTitle="";
    let linkTarget="";

    if (itemData.ExternalLinkUrl || itemData.InternalLinkUrl) {
        link = (itemData.ExternalLinkUrl && itemData.ExternalLinkUrl.url) ? itemData.ExternalLinkUrl : itemData.InternalLinkUrl;
        if (!link.url) {
            link.url = getPageUrl(link.contentId);
        }
        linkTitle = link.Title;
        if (link.target) {
            linkTarget = "_blank";
        }

        return {
            url:link.url,
            target:linkTarget,
            title: linkTitle,

        }
    }
    return null;
}

//images might be saved in different variables in block
//in frontend in most cases we need just one image, whatever is set is good
//cause could be that some list is reated with micture of different blocks
// in one block image is in icon var, in other iconImage ....
// this checks and returns one of them
export function getImageObj(itemData){

    if (itemData && itemData.LinkImage){
        return itemData.LinkImage;
    }

    if (itemData && itemData.IconImage){
        return itemData.IconImage;
    }

    return null
}


export function isLocalHost(){
    //10.0.2.2 - calls from virtual box
    return (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "10.0.2.2")
}

export function isBackend(){
    const renderer = document.getElementById('application').getAttribute('data-renderer');
    if (renderer==="backend"){
        return true;
    }
    return false;
}

export function isInjectedInCsod(){
    let csodHeader = document.getElementsByClassName("c-page-header");
    if(csodHeader.length>0){
        return true;
    }
    return false;
}

export function findParent(el, cls) {
    while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el,cls)));
    return el;
}

export function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}

export function toCapitalizedWords(name) {
    var words = name.match(/[A-Za-z][a-z]*/g) || [];

    return words.map(capitalize).join(" ");
}

export function capitalize(word) {
    return word.charAt(0).toUpperCase() + word.substring(1);
}

export function camelize(text){
    return text.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
}



// WEBPACK FOOTER //
// ./src/core/helpers/CoreHelpers.js